import callApi from 'lib/callApi';

export async function fetchReportDetail(id) {
  let url = `reports/${id}/`;
  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}
